import { Box, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import TopBar from '../components/TopBar/TopBar';

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Top Bar */}
      <TopBar />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: theme.palette.background.default,
          padding: '30px',
          marginTop: '63px',
          minHeight: 'calc(100vh - 63px)',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '100%',
              sm: '100%',
              md: '1400px',
              lg: '1600px',
              xl: '95%',
            },
            '@media (min-width: 2500px)': {
              maxWidth: '95%',
            },
            '@media (min-width: 3500px)': {
              maxWidth: '96%',
            },
          }}
        >
          {children || <Outlet />}
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
